<template>
  <div>
    <el-drawer :visible.sync="drawer" direction="rtl" size="50%" :modal-append-to-body="false" :before-close="onCancel">
      <BjDivider v-if="form">{{ form.id ? $t('billingPage.updateProfile') : $t('billingPage.createProfile') }}</BjDivider>
      <el-form v-if="drawer" ref="form" :model="form" :rules="rules" :disabled="formDisable" label-width="180px">
        <el-form-item :label="$t('billingPage.boundUser')" prop="clientCode">
          <BjSelectLov v-model="form.clientCode" :clearable="false" :option-list="clientCodeList" :placeholder="$t('chooseText')" />
        </el-form-item>
        <el-form-item :label="$t('billingPage.effectiveDate')+':'" prop="effectiveDate">
          <BjDatePicker v-model="form.effectiveDate" />
        </el-form-item>
        <el-form-item :label="$t('billingPage.description')+':'">
          <BjInput v-model="form.description" :placeholder="$t('inputText')" type="textarea" show-word-limit :maxlength="MAX_LENGTH.BILLMAX" style="width:100%" clearable />
        </el-form-item>
        <el-form-item :label="$t('billingPage.billingProfileTemplate')">
          <el-button type="primary" class="main-btn" @click="choseCategories">{{ $t('billingPage.ChoseProfileTemplate') }}</el-button>
        </el-form-item>
        <div style="margin-top:10px;" v-if="form.categoryCodes && form.categoryCodes.length>0">
          <BjDivider>{{ $t('billingPage.CustomerTier') }}</BjDivider>
          <el-row class="flex-align">
            <el-form-item :label="$t('billingPage.CurrentTier')" style="width:48%">
              <BjSelectLov v-model="form.currentTierId" :clearable="false" :option-list="clientTierList" :placeholder="$t('chooseText')" />
            </el-form-item>
            
            <el-form-item :label="$t('billingPage.EvaluatedTier')" style="width:48%">
              <BjInput v-model="form.evaluatedTier" disabled/>
              <!-- <BjDateRangePicker v-model="form.evaluatedTier" :picker-options="pickerOptions" disabled/> -->
            </el-form-item>
          </el-row>
          

          <div v-for="(item,index) in form.categoryCodes" :key="index">
            <BjDivider>{{ item.group }}</BjDivider>
            <el-table ref="multipleTable" :data="item.billCategories" :header-cell-style="handerMethod" style="width: 100%" border>
              <el-table-column prop="billCategoryName" :label="$t('billingPage.serviceType')" align="center"></el-table-column>
              <el-table-column :label="$t('billingPage.chargeSection')" align="center" width="150">
                <template slot-scope="scope">
                  <span v-if="scope.row.sectionMin">
                    {{ scope.row.sectionMin }}{{ scope.row.unit }}<span v-if="scope.row.sectionMax"> - {{ scope.row.sectionMax }}{{ scope.row.unit }}</span>
                  </span>
                  <span v-else>1</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('billingPage.pricing')" align="center">
                <el-table-column :label="$t('billingPage.pricing')" align="center" width="100">
                  <template slot-scope="scope">${{ scope.row.standardPrice }}<br />
                    (${{ scope.row.cost }})
                  </template>
                </el-table-column>
                <el-table-column :label="$t('billingPage.pricing')" align="center">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.price" class="full-width" :controls="false"
                      onkeyup="this.value = this.value.replace(/[^\d.-]/g,'');"
                    >
                      <template slot="prepend">$</template>
                    </el-input>
                  </template>
                </el-table-column>
              </el-table-column>
              <el-table-column prop="description" :label="$t('billingPage.description')" align="center"></el-table-column>
            </el-table>
          </div>
        </div>
      </el-form>
      <div class="foot" style="margin-top:20px">
        <el-button type="danger" @click="onCancel">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="onComfirm">{{ $t('okText') }}</el-button>
      </div>
    </el-drawer>
    <dialogData ref="dialogData" @submit="onSubmit" />
  </div>
</template>
<script>
import dialogData from './dialogData';
import { billApi } from '@/api';
// import moment from 'moment';

export default {
  components: {
    dialogData
  },
  props: {
    clientCodeList: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      drawer: false,
      form: {
        id: null,
        clientCode: '',
        effectiveDate: '',
        description: '',
        billProfileTemplateId: null,
        categoryCodes: [],
        currentTierId: null
      },
      rules: {
         clientCode: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
         effectiveDate: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
      clientCodeList: [],
      formDisable: false,
      pickerOptions: {
        // // 限制时间选择今天及以后的
        // disabledDate(time) {
        //   return time.getTime() < new Date().getTime() - 3600 * 1000 * 24;
        // },
      },
      clientTierList: []
    };
  },
  created() {
    this._getClientTierList()
  },
  methods: {
    _getClientTierList(){
      billApi.getClientTierList({ size: 99, page: 0}).then(res=>{
        this.clientTierList = res.data.content.map(item => {
          return { label: item.tierName, value: item.id }
        })
      })
    },
     handerMethod({ row, column, rowIndex, columnIndex }) {
      // 让第一行的第二个元素占2行
      if (rowIndex == 0) {
        row[1].rowSpan = 2;
      }
      if (rowIndex == 1) {
        row[0].colSpan = 0;
        row[1].colSpan = 0;
        if (columnIndex == 0 || columnIndex == 1) {
          return {
            display: 'none',
          };
        }
      }
     },
    choseCategories() {
        this.$refs.dialogData.dialogVisible = true;
        this.$nextTick(() => {
          if (this.form.billProfileTemplateId) {
            this.$refs.dialogData.toggleSelection(this.form.billProfileTemplateId);
          }
        });
    },
    hide() {
      this.formDisable = false;
      this.drawer = false;
    },
    /** 关闭弹窗 */
    /** 取消 */
    onCancel() {
      this.hide();
      this.$emit('close', true, this.form);
    },
    /** 确定 */
    onComfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.categoryCodes.length == 0) return this.msgSuccess(this.$t('billingPage.ChoseProfileTemplate') + this.$t('emptyWarningText'));
          const categoryList = this.form.categoryCodes.map(item => {
            return item.billCategories.map(jitem => {
              return {
                billCategoryCode: jitem.billCategoryCode,
                price: jitem.price
              };
            });
          });
          const obj = Object.assign({}, this.form, { categoryCodes: categoryList.flat() });
          this.hide();
          this.$emit('handleConfirm', obj);
        }
      });
    },
    onSubmit(rows) {
      rows.categoryCodes.forEach(item => {
        item.billCategories.forEach((jitem) => {
          this.form.categoryCodes.forEach(ktem => {
            ktem.billCategories.forEach((litem) => {
              if (jitem.billCategoryId == litem.billCategoryId) {
                jitem.price = litem.price;
              }
            });
          });
        });
      });
      this.form = {...this.form, ...rows};
      const startDate = new Date(this.form.profileTemplate.gmtCreate);
      const endDate = new Date(this.form.profileTemplate.gmtUpdate);

      // this.form.evaluatedTier = [startDate, endDate]
      this.pickerOptions = {
          disabledDate(time) {
              return time.getTime() < startDate.getTime() || time.getTime() > endDate.getTime();
          },
      };
    }
  },
};
</script>
<style lang="scss">
.flex-item {
  width: 200px;
  justify-content: space-between;
  align-items: flex-start;
}
.el-drawer__body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.el-form {
  flex: 1;
}
.foot {
  text-align: center;
  .el-button {
    width: 120px;
  }
}
</style>
